/**
 * Sentry, started before anything else in the bundle runs.
 *
 * A sidecar rather than a call inside `main.tsx` because the SDK has to be
 * initialised before the modules it instruments are evaluated — it patches
 * `fetch`, `history` and the global error handlers, and anything that captured a
 * reference to those first keeps the unpatched one. `main.tsx` imports this file
 * on its first line, so the import graph guarantees the ordering that a function
 * call in the middle of `main.tsx` would not.
 *
 * It is also why this file has no exports: it is imported for its side effect.
 *
 * Does nothing when `VITE_SENTRY_DSN` is unset — see `./lib/sentry.ts`, which
 * owns every decision about what is sent and what deliberately is not.
 */
import { initSentry } from "@/lib/sentry";
import { syncSentryUserWithAuth } from "@/lib/sentryAuth";

if (initSentry()) {
  // Only when there is a client to tell. The subscription is cheap, but
  // guarding it keeps the unconfigured case genuinely inert.
  syncSentryUserWithAuth();
}
